
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Hide, Show, Text, VStack } from '@chakra-ui/react'
import { useAuth } from 'context'
import { AuthRecoveryPasswordFormType } from 'context/types'
import { RECOVERY_PASSWORD_SCHEMA } from 'context/validations'
import { Formik } from 'formik'
import { themeColors } from 'theme'

import { InputControl, SubmitButton } from 'components/InputCustom'
import { WicarLogo, WicarLogoSmall } from 'components/SVGS'
import { customToast } from 'components/ToastCustom'


export const ResetPassword = () => {
  const { recoveryPassword, clearError, authState: { loading, error } } = useAuth()
  const navigate = useNavigate()
  const {
    container: { gradientColor: { gradientOne, gradientTwo, gradientThree } },
  } = themeColors

  const initialValues: AuthRecoveryPasswordFormType = {
    email: '',
  }

  const obscureEmail = (email: string) => {
    const [name, domain] = email.split('@')

    return `${name[0]}${new Array(name.length).join('*')}@${domain}`
  }

  const handleOnSubmit = async (values: AuthRecoveryPasswordFormType) => {
    const success = await recoveryPassword(values)

    if (success) {
      const description = obscureEmail(values.email)

      customToast.showToast({ description: `Se enviarán instrucciones a ${description}`, status: 'success' })
      navigate('/')
    }
  }

  useEffect(() => {
    if (error)
      customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return (
    <VStack
      minH={'100vh'}
      minW={'100vw'}
      bgGradient={`linear(to-b, ${gradientOne}, ${gradientTwo}, ${gradientThree})`}>
      <Formik
        enableReinitialize
        validateOnMount
        initialValues={initialValues}
        onSubmit={handleOnSubmit}
        validationSchema={RECOVERY_PASSWORD_SCHEMA}>
        <VStack
          flex={1}
          mx="auto"
          w={'full'}
          maxW={{ base: '90%', md: '550px' }}
          h={'fit-content'}
          rounded='2xl'
          p={{ base: 2, md: 4 }}
          justifyContent='center'
          alignItems='center'
          spacing={{ base: 4, md: '70px' }}>
          <VStack>
            <Show below='md'>
              <WicarLogoSmall onClick={() => navigate('/')} width={50} height={50} />
            </Show>
            <Hide below='md'>
              <WicarLogo onClick={() => navigate('/')} width={200} height={50} />
            </Hide>
          </VStack>
          <VStack w={'full'} justifyContent={'center'} alignItems={'center'} spacing={'60px'}>
            <VStack>
              <Text variant={'LG_SB'} textAlign={'center'}>Restablece tu contraseña</Text>
              <Text textAlign={'center'}>
                Ingresa tu correo electrónico para recuperar el acceso a tu cuenta
              </Text>
            </VStack>
            <VStack w={'full'} maxW={'330px'} spacing={'32px'}>
              <InputControl
                inputProps={{ placeholder: 'Ingresar correo electrónico' }}
                name='email'
                label='Correo electrónico'
                isDisabled={loading}
              />
              <SubmitButton w={'full'} loadingText={'Solicitando...'} isLoading={loading}>
                solicitar contraseña
              </SubmitButton>
              <Button w={'full'} variant={'secondary'} disabled={loading} onClick={() => navigate('/')}>
                Volver
              </Button>
            </VStack>
          </VStack>
        </VStack>
      </Formik>
    </VStack>
  )
}
